<template>
  <div class="main width-100 height-100">
    <div class="preview-main width-100 height-100" v-if="!isGenerating && !error">
      <pdf-viewer
        v-if="viewer === 'pdf'"
        :previewInfo="previewInfo"
        :item="fileItem"
        @state-changed="handlePdfStateChanged"
        @onpageclick="toggleShareHidden"
      />
      <image-swipe
        v-if="viewer === 'image'"
        :item="fileItem"
        :previewInfo="previewInfo"
        :renderLimit="renderLimit"
        @state-change="handleChangeState"
        @image-swipe="handleImageSwipe"
        @image-tap="toggleShareHidden"
      />
      <cad-viewer
        v-else-if="viewer === 'cad'"
        :previewInfo="previewInfo"
        :item="fileItem"
      />
      <application-viewer
          v-else-if="['ngm','xmd'].includes(viewer)"
          :previewInfo="previewInfo"
          :item="fileItem"
          :kind="viewer"
          :scenario="scenario"
      />
      <wps-viewer
        v-else-if="viewer === 'wps'"
        @state-changed="handleWpsStateChanged"
        @onpageclick="toggleShareHidden"
        :previewInfo="previewInfo"
        :item="fileItem"
        :url="previewInfo.preview_url"
      />
      <div v-else-if="viewer === 'video'" class="width-100 height-100" style="background-color: #ffffff;">
        <div class="video-container">
          <video-viewer
            :previewInfo="previewInfo"
            :item="fileItem"
            @video-error="handleVideoError"
          />
        </div>
      </div>
      <div v-else-if="viewer === 'yiqixie'" class="width-100 height-100" style="background-color: #ffffff;">
        <div class="yqx-container">
          <yqx-viewer :item="fileItem"/>
        </div>
      </div>
    </div>

    <!-- <transition name="share-translate">
      <div bk id="onPreviewGotoShareClicked"
        v-show="!shareHidden && !loading"
        class="btn-share direction-row justify-center align-items-center"
        v-on:click="share"
      >
        <svg-icon class="svg-img flex-0-0-auto" icon="weixin-white1"></svg-icon>
        <div class="share-text flex-0-0-auto">分享至微信群/朋友</div>
      </div>
    </transition> -->

    <div v-if="error" class="preview-error width-100 height-100 justify-center align-items-center">
      <div class="direction-column justify-center align-items-center">
        <svg-icon class="error-icon flex-0-0-auto" icon="empty-default"></svg-icon>
        <div class="error-text">{{ errorMsg }}</div>
      </div>
    </div>

    <div
      v-if="isGenerating"
      class="preview-generating width-100 height-100 justify-center align-items-center"
    >
      <genetating-status-view :percent="percent"></genetating-status-view>
    </div>
  </div>
</template>

<script>
import PdfViewer, {PdfState} from '../preview/PdfViewer'
import ImageSwipe from '../preview/ImageSwipe'
import ImageViewer from '../preview/ImageViewer'
// import VideoViewer from './VideoViewer'
import VideoViewer from '../preview/VCloudPlayerViewer'
import YqxViewer from '../preview/YqxViewer'
import WpsViewer, {WpsState} from '../preview/WpsViewer'
import CadViewer from '../preview/CadViewer'
import ApplicationViewer from '../preview/ApplicationViewer'
import GenetatingStatusView from './GeneratingStatusView'
import { FILE_INFO, FILE_LIST } from '@/config/api'
import wxajax from '@/utils/wxajax'
import { normalizeFile } from '@/utils/fileUtils'
import PreviewCore from '@/utils/PreviewCore'
import PreviewLog from '../../log/PreviewLog'
import WxApi from '../../utils/WxApi.js'
import BLWxPreview from '@/bi/blWxPreview'
import PreviewTimer from '@/bi/previewTimer'
import track from '@/utils/eventTrack'

export default {
  name: 'WxPreviewView',
  components: {
    PdfViewer,
    ImageSwipe,
    ImageViewer,
    VideoViewer,
    YqxViewer,
    WpsViewer,
    CadViewer,
    ApplicationViewer,
    GenetatingStatusView
  },
  computed: {
    scenario () {
      return this.$route.query.unique_name ? 'share' : undefined
    },
    renderLimit () {
      return (
        this.previewInfo.category === 'watermark_preview' ||
        !this.permDownload ||
        this.fileItem.is_encrypted
      )
    }
  },
  data () {
    return {
      shareHidden: false,
      previewInfo: {},
      isGenerating: true,
      loading: true,
      fileId: null,
      rootId: null,
      fileItem: {},
      previewCore: PreviewCore,
      error: false,
      errorMsg: '',
      percent: 0,
      viewer: '',
      previewTimer: Object,
      timeStamp: 0
    }
  },
  created () {
    // 添加qdas脚本
    track.scriptLoader()

    // 添加微信小程序的JS脚本
    let wxScript = document.createElement('script')
    wxScript.setAttribute(
      'src',
      'https://res.wx.qq.com/open/js/jweixin-1.4.0.js'
    )
    document.head.appendChild(wxScript)

    this.previewTimer = PreviewTimer.createTimer()

    this.fileId = parseInt(this.$route.params.file_id)
    this.rootId = parseInt(this.$route.query.root_id)
    this.loading = true
    wxajax({
      url: `${FILE_INFO}?item_typed_id=file_${this.fileId}`,
      errorCallBack: () => {
        WxApi.switchTab(WxApi.PAGE_HOME)
      }
    }).then(result => {
      if (result.success) {
        this.fileItem = result.item
        normalizeFile(this.fileItem)

        this.previewCore = new PreviewCore({
          item: this.fileItem,
          stateChangedCallback: this.handleChangeState,
          scenario: this.scenario
        })

        let kind = this.getKind()
        if (this.rootId > 0 && (kind === 'image_1024' || kind === 'image')) { // 图片因为要支持预览多张，所以要先拉取文件列表
          wxajax({
            url: `${FILE_LIST}/${this.rootId}?limit=25`
          }).then(result => {
            if (result.success) {
              result.children.forEach(item => {
                if (item.extension_category === 'image') {
                  this.store.imgPreviewInfo.ids.push(item.id)
                  this.store.imgPreviewInfo.items[item.id] = item
                }
              })
            }
            this.loading = false
            this.startPreview()
          })
        } else {
          this.loading = false
          if (kind === 'pdf') { // 暂时只统计pdf
            this.previewTimer.start().then(canceled => {
              if (!canceled) {
                BLWxPreview.error('preview timeout!')
              }
            })
          }
          this.startPreview()
        }
      }
    })
  },
  beforeDestroy () {
    this.previewCore && this.previewCore.destroy()
  },
  watch: {
    percent (val) {
      if (val === 100) {
        this.clearStatus()
      }
    }
  },
  methods: {
    toggleShareHidden: function () {
      this.shareHidden = !this.shareHidden
    },
    handlePdfStateChanged: function (state) {
      if (state === PdfState.PSPDFKIT_SUCCEED) {
        this.previewTimer.cancel()
        PreviewLog.succeed(this.fileItem.id, Math.max(0, new Date().getTime() - this.timeStamp))
      } else if (state === PdfState.PSPDFKIT_FAILED) {
        this.previewTimer.cancel()

        // pspdf预览失败后自动切换为pdfjs预览
        this.error = false
        this.previewCore.previewFile({
          type: 'pdf_enc',
          notFirst: true
        })
      } else if (state === PdfState.PDFJS_SUCCEED) {
        PreviewLog.succeed(this.fileItem.id, Math.max(0, new Date().getTime() - this.timeStamp))
        this.previewTimer.cancel()
      } else if (state === PdfState.PDFJS_FAILED) {
        this.previewTimer.cancel()
        PreviewLog.previewError(this.fileItem.id, Math.max(0, new Date().getTime() - this.timeStamp), 'pspdfjs load failed')
      }
    },
    share: function (event) {
      track.click(event)
      WxApi.navigateTo(WxApi.PAGE_SHARE_CREATE, { fileId: this.fileId })
    },
    handleChangeState (data) {
      if (data.previewInfo) {
        this.previewInfo = data.previewInfo
      }
      if ('error' in data && data.error) {
        this.error = true
        this.isGenerating = false
        if (data.errorMessage) {
          this.errorMsg = data.errorMessage
        } else {
          this.errorMsg = '预览失败'
        }
        const kind = this.getKind()
        if (data.reason && data.reason === 'not_support') {
          BLWxPreview.sum(BLWxPreview.EVENT_NOT_SUPPORT, 1)
          if (PreviewLog.needLog(kind)) {
            PreviewLog.notSupportError(this.fileItem, kind, Math.max(0, new Date().getTime() - this.timeStamp))
          }
        } else {
          BLWxPreview.error(data.errorMessage)
          if (PreviewLog.needLog(kind)) {
            PreviewLog.transformError(this.fileItem.id, Math.max(0, new Date().getTime() - this.timeStamp), data.errorMessage)
          }
        }
      } else {
        if ('percent' in data && data.percent > 0) {
          this.percent = data.percent
        }

        if ('generatingStatus' in data) {
          this.isGenerating = !(data.generatingStatus === 'generated')
        }

        if ('isGenerating' in data) {
          this.isGenerating = data.isGenerating
        }

        if ('viewer' in data) {
          this.viewer = data.viewer
        }

        if (
          data.previewInfo &&
          this.viewer === 'image' &&
          !this.store.imgPreviewInfo.ids.includes(this.fileItem.id)
        ) {
          this.store.imgPreviewInfo.ids.push(this.fileItem.id)
          this.store.imgPreviewInfo.items[this.fileItem.id] = this.fileItem
        }
      }
    },
    handleWpsStateChanged: function (state) {
      if (state === WpsState.SUCCEED) {
        PreviewLog.succeed(this.fileItem.id, Math.max(0, new Date().getTime() - this.timeStamp))
      } else if (state === WpsState.FAILED) {
        PreviewLog.previewError(this.fileItem.id, Math.max(0, new Date().getTime() - this.timeStamp), 'wps load failed')
      }
    },
    handleVideoError () {
      this.error = true
      this.errorMsg = this.previewCore.translateErrorMsg('media_not_support')
    },
    handleImageSwipe (item) {
      this.$router.replace({query: {...this.$route.query, file_id: item.id}})
      this.fileItem = item
      this.fileId = item.id
    },
    getKind () {
      let { extension_category, extension } = this.fileItem
      return this.previewCore.getKind(extension, extension_category)
    },
    openFile (kind) {
      if (kind) {
        this.previewCore.start(kind)
      } else {
        this.isGenerating = false
        this.error = true
        this.errorMsg = this.previewCore.translateErrorMsg('not_support')
      }
    },
    clearStatus () {
      if (this.generatingStatus || this.isGenerating) {
        setTimeout(() => {
          this.generatingStatus = ''
          this.isGenerating = false
        }, 100)
      }
    },
    startPreview () {
      this.timeStamp = new Date().getTime()
      BLWxPreview.sum(BLWxPreview.EVENT_PREVIEW, 1)

      this.error = false

      const kind = this.getKind()
      this.openFile(kind)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import 'layout';
.main {
  position: relative;
  background-color: #eeeff5;
  box-sizing: border-box;

  & > .preview-main {
    left: 0px;
    top: 0px;
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;
    background-color: #777;

    & .video-container {
      margin-left: 16px;
      margin-right: 16px;
      height: 300px;
      background-color: #000000;
    }

    & .yqx-container {
      height: 100%;
      padding-bottom: 60px;
      box-sizing: border-box;
    }

    & .pdf-js {
      height: 100%;
      overflow: auto;
    }
  }

  & > .preview-error {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 1;
    background-color: #ffffff;
    box-sizing: border-box;
  }

  & > .preview-generating {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 1;
    background-color: #ffffff;
    box-sizing: border-box;
  }

  & > .btn-share {
    position: absolute;
    height: 47px;
    width: 90%;
    border-radius: 23.5px;
    z-index: 2;
    bottom: 12px;
    box-shadow: 0 3px 6px 0 rgba(153, 153, 153, 0.08);
    background-color: #6ca2ff;
    margin-right: 5%;
    margin-left: 5%;
    box-sizing: border-box;

    & .svg-img {
      width: 20px;
      height: 20px;
    }

    & .share-text {
      height: 22px;
      opacity: 0.89;
      font-family: PingFangSC;
      margin-left: 8px;
      font-size: 18px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.22;
      letter-spacing: normal;
      color: #ffffff;
    }
  }
}

.share-translate-enter-active,
.share-translate-leave-active {
  transition: all 0.2s;
}
.share-translate-enter,
.share-translate-leave-to {
  transform: translateY(60px);
}
</style>
